module.exports = __webpack_public_path__ + "img/login-logo.95db9149.png";